import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, ResolveFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const AppAuthResolver: ResolveFn<void> =
  (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
    return inject(AuthService).init();
  };
